import React from 'react'

interface CPMSliderProps {
  label: string
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
  step?: number
  disabled?: boolean
}

const CPMSlider: React.FC<CPMSliderProps> = ({
  label,
  value,
  onChange,
  min = 0,
  max = 1,
  step = 0.001,
  disabled = false
}) => {
  // Ensure value is a valid number, default to min if not
  const safeValue = typeof value === 'number' && !isNaN(value) ? value : min

  // Calculate percentage for gradient
  const percentage = ((safeValue - min) / (max - min)) * 100

  // Format as CPM (rate * 1000)
  const formatAsCPM = (val: number): string => {
    const safeVal = typeof val === 'number' && !isNaN(val) ? val : 0
    const cpm = safeVal * 1000
    // Show 2 decimal places for values under $10, otherwise whole numbers
    if (cpm < 10) {
      return `$${cpm.toFixed(2)}`
    }
    return `$${cpm.toFixed(0)}`
  }

  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between">
        <label className="text-[10px] font-medium text-gray-600">{label}</label>
        <span className="text-[10px] font-mono text-gray-700">{formatAsCPM(safeValue)} <span className="text-[9px] text-gray-400">CPM</span></span>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={safeValue}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        disabled={disabled}
        className="w-full h-1.5 rounded-lg appearance-none cursor-pointer disabled:cursor-not-allowed disabled:opacity-50"
        style={{
          background: `linear-gradient(to right, #3b82f6 0%, #3b82f6 ${percentage}%, #e5e7eb ${percentage}%, #e5e7eb 100%)`
        }}
      />
      <style>{`
        input[type='range']::-webkit-slider-thumb {
          appearance: none;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: white;
          border: 2px solid #3b82f6;
          cursor: pointer;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
          transition: transform 0.15s ease;
        }
        input[type='range']::-webkit-slider-thumb:hover {
          transform: scale(1.1);
        }
        input[type='range']::-moz-range-thumb {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: white;
          border: 2px solid #3b82f6;
          cursor: pointer;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
        }
        input[type='range']:disabled::-webkit-slider-thumb {
          cursor: not-allowed;
          background: #e5e7eb;
          border-color: #9ca3af;
        }
      `}</style>
    </div>
  )
}

export default CPMSlider
